import Grid2 from '@mui/material/Grid2';
import { AlignItemsTypes, ChildrenProps, DisplayTypes, JustifyContentTypes, LiteralStringOrArrayOfLiteralStrings, appendClassName } from '@componentLibraryWrapper/common';
import './grid.scss';

export interface GridProps extends ChildrenProps<HTMLDivElement> {
	xs?: number,
  sm?: number,
  md?: number,
  lg?: number,
  xl?: number,
	alignItems?: LiteralStringOrArrayOfLiteralStrings<AlignItemsTypes>,
	container?: boolean,
	display?: LiteralStringOrArrayOfLiteralStrings<DisplayTypes>,
	justifyContent?: LiteralStringOrArrayOfLiteralStrings<JustifyContentTypes>,
	spacing?: number | string
}

const Grid = ({
	className,
	container=false,
	spacing=0,
	xs,
	sm,
	md,
	lg,
	xl,
	...rest
}: GridProps) => {
	
	// container and spacing properties can only be utilized together.
	const restExtended = container ? {...rest, container: container, spacing: spacing} : rest;

	return (
		<Grid2
			{...restExtended}
			className={appendClassName('sm-grid', className)}
			size={{
				xs: xs,
				sm: sm,
				md: md,
				lg: lg,
				xl: xl
			}}/>
	)
}

export default Grid;